import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@/shared/ui/select';
import { ReceivableStatus } from '../../utils/types';
import { DateRange } from 'react-day-picker';
import { DateRangePicker } from '@/shared/widgets/DateRangePicker';

interface Props {
  search: string;
  onSearchChange: (value: string) => void;
  statusFilter: ReceivableStatus | 'all';
  onStatusFilterChange: (value: ReceivableStatus | 'all') => void;
  dateReferenceRange?: DateRange;
  onDateReferenceRangeChange?: (range: DateRange | undefined) => void;
  paidDateRange?: DateRange;
  onPaidDateRangeChange?: (range: DateRange | undefined) => void;
}

export function ReceivableFilters({
  search,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  dateReferenceRange,
  onDateReferenceRangeChange,
  paidDateRange,
  onPaidDateRangeChange,
}: Props) {
  return (
    <div className="flex flex-col gap-4 w-full md:flex-row md:items-center">
      {/* Status */}
      <Select
        value={statusFilter}
        onValueChange={v => onStatusFilterChange(v as ReceivableStatus | 'all')}
      >
        <SelectTrigger className="w-full md:w-[160px]">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos os status</SelectItem>
          <SelectItem value={ReceivableStatus.WAITING}>Aguardando</SelectItem>
          <SelectItem value={ReceivableStatus.RECEIVED}>Recebido</SelectItem>
          <SelectItem value={ReceivableStatus.CONCLUDED}>Concluído</SelectItem>
          <SelectItem value={ReceivableStatus.CALCULATING}>Calculando</SelectItem>
          <SelectItem value={ReceivableStatus.CALCULATED}>Calculado</SelectItem>
          <SelectItem value={ReceivableStatus.FAIL}>Falhou</SelectItem>
        </SelectContent>
      </Select>
      {/* Data de referência */}
      {typeof onDateReferenceRangeChange === 'function' && (
        <div className="w-full md:w-[280px]">
          <DateRangePicker
            dateRange={dateReferenceRange}
            setDateRange={onDateReferenceRangeChange}
            placeholder="Período de referência"
          />
        </div>
      )}
      {typeof onPaidDateRangeChange === 'function' && (
        <div className="w-full md:w-[280px]">
          <DateRangePicker
            dateRange={paidDateRange}
            setDateRange={onPaidDateRangeChange}
            placeholder="Período de pagamento"
          />
        </div>
      )}
    </div>
  );
}
